/* tslint:disable */
/* eslint-disable */
/**
 * Registration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountPhoto
 */
export interface AccountPhoto {
    /**
     * 
     * @type {string}
     * @memberof AccountPhoto
     */
    absoluteUrl: string;
}

/**
 * Check if a given object implements the AccountPhoto interface.
 */
export function instanceOfAccountPhoto(value: object): value is AccountPhoto {
    if (!('absoluteUrl' in value) || value['absoluteUrl'] === undefined) return false;
    return true;
}

export function AccountPhotoFromJSON(json: any): AccountPhoto {
    return AccountPhotoFromJSONTyped(json, false);
}

export function AccountPhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountPhoto {
    if (json == null) {
        return json;
    }
    return {
        
        'absoluteUrl': json['absoluteUrl'],
    };
}

export function AccountPhotoToJSON(value?: AccountPhoto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'absoluteUrl': value['absoluteUrl'],
    };
}

